import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import { SabiasQueNY } from "./nyHelpers";

// Template91: Día 7 Día libre 2 - Tour Contrastes, Washington D.C., Outlets (Page22). Contenido desde page.
const Template91 = ({
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const parseSabiasQueItem = (html) => {
		if (!html) return null;
		const parser = new DOMParser();
		const doc = parser.parseFromString(html, "text/html");
		const p = doc.querySelector("p");
		if (!p) return null;
		const text = (p.textContent ?? p.innerText ?? "").trim();
		if (!text) return null;
		const emojiMatch = text.match(/^([^\s]+)\s+(.*)/s);
		if (emojiMatch)
			return { icono: emojiMatch[1], texto: emojiMatch[2].trim() };
		return null;
	};

	const title = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const tourH3 = page?.texts?.[2]?.content;
	const tourP = page?.texts?.[3]?.content;
	const tourYellow = page?.texts?.[4]?.content;
	const sabiasQueTour = parseSabiasQueItem(page?.texts?.[5]?.content);
	const tourReserveHtml = page?.texts?.[6]?.content;
	const washingtonH3 = page?.texts?.[7]?.content;
	const washingtonP = page?.texts?.[8]?.content;
	const washingtonReserveHtml = page?.texts?.[9]?.content;
	const washingtonStickerYellow = page?.texts?.[10]?.content;
	const sabiasQueWashington = parseSabiasQueItem(page?.texts?.[11]?.content);
	const outletsH3 = page?.texts?.[12]?.content;
	const outlet1 = page?.texts?.[13]?.content;
	const outlet2 = page?.texts?.[14]?.content;
	const outlet3 = page?.texts?.[15]?.content;
	const sabiasQueOutlets = parseSabiasQueItem(page?.texts?.[16]?.content);

	const bronxSrc = getImageSrc("bronx");
	const washingtonSrc = getImageSrc("washington");
	const washingtonStickerSrc = getImageSrc("washington-sticker");
	const logoSrc = getCanvasImageUrl("logo");

	const estiloH3 = {
		fontFamily: '"Poppins", sans-serif',
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const estiloP = {
		fontFamily: '"Poppins", sans-serif',
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	const renderOutletLine = (text) => {
		if (!text) return null;
		const lines = String(text)
			.split("\n")
			.map((s) => s.trim())
			.filter(Boolean);
		const title = lines[0] || "";
		const subtitle = lines[1] ? <em>{lines[1]}</em> : null;
		return (
			<>
				{title.includes(":") ? (
					<>
						<strong>{title.split(":")[0]}:</strong>{" "}
						{title.split(":").slice(1).join(":").trim()}
					</>
				) : (
					title
				)}
				{subtitle && (
					<>
						<br />
						{subtitle}
					</>
				)}
			</>
		);
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				backgroundColor: "#f7f7f7",
				position: "relative",
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
				"& p": { marginTop: "0px !important", marginBottom: "0px !important" },
				"& a": {
					color: "#caa100",
					textDecoration: "underline",
					fontWeight: "bold",
				},
			}}
		>
			<div
				data-block-id="header"
				style={{
					backgroundColor: headerBackgroundColor || "#59c3d8",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontFamily: fontFamily || '"Poppins", sans-serif',
					fontSize: "14px",
					fontWeight: 700,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 9999,
				}}
			>
				{title}
				{logoSrc && (
					<img
						src={logoSrc}
						alt="logo"
						style={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</div>

			{intro && (
				<div
					data-block-id="text-1"
					style={{ padding: "12px 16px", fontFamily: '"Poppins", sans-serif' }}
				>
					<p style={estiloP}>{intro}</p>
				</div>
			)}

			<div
				style={{
					padding: "0 16px",
					display: "flex",
					flexDirection: "column",
					gap: 16,
				}}
			>
				{(tourH3 || tourP) && (
					<div
						data-block-id="text-2"
						style={{
							display: "flex",
							gap: 16,
							position: "relative",
							marginBottom: 12,
						}}
					>
						<div>
							{tourH3 && <h3 style={estiloH3}>{tourH3}</h3>}
							<div style={{ position: "relative" }}>
								{bronxSrc && tourYellow && (
									<>
										<img
											src={bronxSrc}
											alt="Bronx"
											style={{
												width: 110,
												position: "absolute",
												bottom: -10,
												right: -50,
											}}
										/>
										<div
											style={{
												position: "absolute",
												bottom: isSmallScreen ? 30 : 30,
												right: isSmallScreen ? 30 : 50,
												backgroundColor: "#fff8db",
												border: "2px solid #f5c400",
												borderRadius: "16px 16px 0px 16px",
												padding: "10px 12px",
												fontSize: 11,
												fontFamily: '"Poppins", sans-serif',
												color: "#444",
												boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
												maxWidth: 90,
											}}
										>
											{tourYellow}
										</div>
									</>
								)}
								{tourP && (
									<p
										style={{
											...estiloP,
											width: isSmallScreen ? "60%" : "70%",
										}}
									>
										{tourP}
									</p>
								)}
							</div>
						</div>
						{sabiasQueTour && (
							<div
								style={{
									position: "absolute",
									bottom: isSmallScreen ? -30 : -20,
									right: "40%",
								}}
							>
								<SabiasQueNY
									icono={sabiasQueTour.icono}
									texto={sabiasQueTour.texto}
								/>
							</div>
						)}
					</div>
				)}

				{tourReserveHtml && (
					<div
						data-block-id="text-3"
						style={{
							backgroundColor: "#fff8db",
							border: "2px solid #f5c400",
							borderRadius: 12,
							padding: "10px 12px",
							marginTop: isSmallScreen ? 0 : -20,
							fontSize: 12,
							fontFamily: '"Poppins", sans-serif',
							color: "#444",
						}}
					>
						<span dangerouslySetInnerHTML={{ __html: tourReserveHtml }} />
					</div>
				)}

				{(washingtonH3 || washingtonP || washingtonSrc) && (
					<div data-block-id="text-4" style={{ display: "flex", gap: 16, position: "relative" }}>
						{washingtonSrc && (
							<img
								src={washingtonSrc}
								alt="Washington D.C."
								style={{
									width: "40%",
									borderRadius: 12,
									objectFit: "cover",
									height: 110,
								}}
							/>
						)}
						<div style={{ width: "60%" }}>
							{washingtonH3 && <h3 style={estiloH3}>{washingtonH3}</h3>}
							{washingtonP && <p style={estiloP}>{washingtonP}</p>}
							{washingtonReserveHtml && (
								<div
									style={{
										backgroundColor: "#fff8db",
										border: "2px solid #f5c400",
										borderRadius: 12,
										padding: "10px 12px",
										marginTop: 10,
										fontSize: 12,
										fontFamily: '"Poppins", sans-serif',
										color: "#444",
									}}
								>
									<span
										dangerouslySetInnerHTML={{ __html: washingtonReserveHtml }}
									/>
								</div>
							)}
						</div>
						{sabiasQueWashington && (
							<div style={{ position: "absolute", bottom: -30, right: "50%" }}>
								<SabiasQueNY
									icono={sabiasQueWashington.icono}
									texto={sabiasQueWashington.texto}
								/>
							</div>
						)}
						{washingtonStickerSrc && washingtonStickerYellow && (
							<>
								<img
									src={washingtonStickerSrc}
									alt="Washington"
									style={{
										width: 110,
										position: "absolute",
										bottom: -57,
										left: -30,
									}}
								/>
								<div
									style={{
										position: "absolute",
										bottom: 20,
										left: -12,
										backgroundColor: "#fff8db",
										border: "2px solid #f5c400",
										borderRadius: "16px 16px 16px 0px",
										padding: "10px 12px",
										fontSize: 11,
										fontFamily: '"Poppins", sans-serif',
										color: "#444",
										boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
										maxWidth: 99,
									}}
								>
									{washingtonStickerYellow}
								</div>
							</>
						)}
					</div>
				)}

				{outletsH3 && (outlet1 || outlet2 || outlet3) && (
					<div
						data-block-id="text-5"
						style={{
							backgroundColor: "#e0f7fa",
							border: "2px solid #59c3d8",
							borderRadius: 16,
							padding: 16,
							marginTop: 20,
							position: "relative",
							marginBottom: isSmallScreen ? 12 : 0,
						}}
					>
						<h3
							style={{
								fontFamily: '"Poppins", sans-serif',
								fontSize: 14,
								fontWeight: 700,
								textTransform: "uppercase",
								marginBottom: 12,
								marginTop: 0,
								color: "#007a8d",
							}}
						>
							{outletsH3}
						</h3>
						<ul style={{ paddingLeft: 18, margin: 0 }}>
							{outlet1 && <li style={estiloP}>{renderOutletLine(outlet1)}</li>}
							{outlet2 && (
								<li style={{ ...estiloP, marginTop: 12 }}>
									{renderOutletLine(outlet2)}
								</li>
							)}
							{outlet3 && (
								<li style={{ ...estiloP, marginTop: 12 }}>
									{renderOutletLine(outlet3)}
								</li>
							)}
						</ul>
						{sabiasQueOutlets && (
							<div style={{ position: "absolute", top: -15, left: "30%" }}>
								<SabiasQueNY
									icono={sabiasQueOutlets.icono}
									texto={sabiasQueOutlets.texto}
								/>
							</div>
						)}
					</div>
				)}
			</div>
		</Box>
	);
};

export default Template91;
